/**
 * IIIF Linking API
 * ============================================================================
 * This section is still a work in progress. Its not clear what will be
 * normalized on the way into the redux state.
 *
 * - getSeeAlso
 * - getService
 * - getRelated
 * - getRendering
 * - getWithin
 * - getStartCanvas
 */
var getSeeAlso = function getSeeAlso(resource) {
  return resource.seeAlso || [];
};

var getService = function getService(resource) {
  return resource.service || [];
};

var getRelated = function getRelated(resource) {
  return resource.related || [];
};

var getRendering = function getRendering(resource) {
  return resource.rendering || [];
};

var getWithin = function getWithin(resource) {
  return resource.within || [];
};

var getStartCanvas = function getStartCanvas(resource) {
  return resource.startCanvas || null;
};

export { getSeeAlso, getService, getRelated, getRendering, getStartCanvas, getWithin };